import React from 'react';
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { LinkModel } from '../../models/globals';
import { useTouchableDropdown } from '../../hooks/useTouchableDropdown';
import SearchIcon from '../../svgs/search.svg';
import XIcon from '../../svgs/x.svg';
import CartIcon from '../../svgs/carticon.svg';
import { ArrowToggle } from './ArrowToggle';

interface AccountAndSearchProps {
    accountLinks: LinkModel[];
    showSearch: boolean;
    showStudentLoginLink: boolean;
    studentLoginLink: LinkModel;
    toggleShowSearch(): void;
    shoppingCartCount: number;
    shoppingCartLink: LinkModel;
}

const AccountAndSearch: React.FC<AccountAndSearchProps> = ({
    accountLinks,
    showSearch,
    studentLoginLink,
    showStudentLoginLink,
    toggleShowSearch,
    shoppingCartCount,
    shoppingCartLink,
}) => {
    const showCart = shoppingCartCount > 0;
    const { dropdown: accountDropdown } = useTouchableDropdown();

    return (
        <Nav className="d-block">
            <Navbar.Text>
                {showStudentLoginLink ? (
                    <Nav.Link href={studentLoginLink.url}>{studentLoginLink.name}</Nav.Link>
                ) : (
                    <Dropdown
                        {...accountDropdown}
                        alignRight
                        as={Nav.Item}
                        className="account-nav-dropdown navitem-border-bottom"
                        focusFirstItemOnShow="keyboard"
                    >
                        <Dropdown.Toggle as={ArrowToggle} id="account-nav-dropdown">
                            Account
                        </Dropdown.Toggle>

                        <Dropdown.Menu renderOnMount>
                            {accountLinks.map(({ name, url }) => (
                                <Dropdown.Item active={false} href={url} key={name}>
                                    <span className="menu-border-bottom">{name}</span>
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                )}
            </Navbar.Text>

            <Button
                className="px-2"
                onClick={toggleShowSearch}
                title={`${showSearch ? 'Hide' : 'Show'} search`}
                variant="link"
            >
                {showSearch ? <XIcon className="x-icon" /> : <SearchIcon />}
            </Button>

            {showCart && (
                <Button
                    href={shoppingCartLink.url}
                    className="pb-0 px-2 position-relative"
                    variant="link"
                    aria-label={`You have ${shoppingCartCount} items in your shopping cart`}
                >
                    <span className="e2g-hosted-cart-ico-counter">{shoppingCartCount}</span>
                    <CartIcon />
                </Button>
            )}
        </Nav>
    );
};

export { AccountAndSearch, AccountAndSearchProps };
